import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

const SectionCardSkeleton = () => {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Box sx={{ 
        width: '100%',
        height: '100%',
        p: 2,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 1
      }}>
        <Skeleton variant="rectangular" width="100%" height={140} sx={{ borderRadius: 2, mb: 1 }} />
        <Skeleton variant="text" width="80%" height={32} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="60%" height={24} />
      </Box>
    </Grid>
  );
};

export default SectionCardSkeleton;